const AUTH_JOURNEY_STORAGE_KEY = 'aprendos:pending-auth-journey';
const AUTH_JOURNEY_VERSION = 1;

function normalizeLanguage(language) {
  const normalized = String(language || '').trim().toLowerCase();
  if (normalized.startsWith('es')) return 'es';
  if (normalized.startsWith('no') || normalized.startsWith('nb') || normalized.startsWith('nn')) return 'no';
  return 'en';
}

function safeInternalPath(path, language) {
  const fallback = `/${normalizeLanguage(language)}/onboarding/welcome`;
  if (typeof path !== 'string') return fallback;

  const trimmed = path.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return fallback;
  return trimmed;
}

export function savePendingAuthJourney(storage, journey = {}) {
  if (!storage) return null;

  const language = normalizeLanguage(journey.language);
  const pendingJourney = {
    version: AUTH_JOURNEY_VERSION,
    source: journey.source || 'signup',
    demoId: journey.demoId || '',
    language,
    level: journey.level || '',
    accessCode: String(journey.accessCode || '').trim(),
    returnTo: safeInternalPath(journey.returnTo, language),
  };

  try {
    storage.setItem(AUTH_JOURNEY_STORAGE_KEY, JSON.stringify(pendingJourney));
    return pendingJourney;
  } catch {
    return null;
  }
}

export function getPendingAuthJourney(storage) {
  if (!storage) return null;

  try {
    const journey = JSON.parse(storage.getItem(AUTH_JOURNEY_STORAGE_KEY));
    if (journey?.version !== AUTH_JOURNEY_VERSION) return null;

    const language = normalizeLanguage(journey.language);
    return {
      ...journey,
      language,
      returnTo: safeInternalPath(journey.returnTo, language),
    };
  } catch {
    return null;
  }
}

export function clearPendingAuthJourney(storage) {
  if (!storage) return;

  try {
    storage.removeItem(AUTH_JOURNEY_STORAGE_KEY);
  } catch {
    // Authentication must continue even when session storage is unavailable.
  }
}
